import { Component } from '@inter-ikea-core/core';
import { LabelPosition } from '../..';

/**
 * Used to store measurement lines labels information.
 * These components are then used by widgets to render
 * labels in the scene.
 */
export default class MeasurementsLabelComponent implements Component {
  static id = 2083;
  measurements: LabelPosition[];
  typeId = MeasurementsLabelComponent.id;
  doStoreInSnapshot: boolean = true;
  serializable: boolean = false;

  constructor(measurements: LabelPosition[]) {
    this.measurements = measurements;
  }

  eq() {
    return false;
  }
}
